module.exports = __webpack_public_path__ + "static/media/BH2020.13ccb7b1.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/BH2020.JPG
// module id = 362
// module chunks = 0